<div *ngFor="let xmlSection of detailsXMLSections">
  <div class="body-table">
    <div class="title" *ngIf="!iagPortalHowDoesItWork">{{ xmlSection.body }}</div>
    <h4 class="flex-text" *ngIf="!iagPortalHowDoesItWork">{{ xmlSection.subBody }}</h4>
    <app-prism-xml [xmlData]="xmlSection.xmlData"></app-prism-xml>
    <div *ngIf="xmlSection.tableSections">
      <app-table-section [tableSections]="xmlSection.tableSections"></app-table-section>
    </div>
  </div>
</div>
